<ion-content>
  <section class="p-20 p-md-10 h-100 w-100">
    <mat-tab-group class="grievance-tabs w-100" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Grievance"></mat-tab>
      <!-- <mat-tab label="Address Grievance" *ngIf="viewAddressGrievance"></mat-tab> -->
      <mat-tab label="Address Grievance"></mat-tab>
    </mat-tab-group>
    
    <div *ngIf="selectedTabIndex == 'allGrievance'" class="pb-10">
      <div class="phi-flex-wrap phi-align-items-md-center phi-gap-12 reverse-cols-on-desktop mb-10">
        <div class="ion-text-end w-100 mw-sm-auto">
          <ion-button type="button" class="gr-btn-primary gr-add-btn" (click)="onAddGrievance()">Add Grievance</ion-button>
        </div>
        <ion-row>
          <ion-col size="6" size-sm="auto">
            <app-grievance-total-count [countData]="{ value: 'Total', count: grievanceTable.tableData.length}"></app-grievance-total-count>
          </ion-col>
          
          <ion-col size="6" size-sm="auto" *ngFor="let status of grievanceServicesService.statusType">
            <app-grievance-total-count [countData]="status"></app-grievance-total-count>
          </ion-col>
        </ion-row>
      </div>
      
      <app-grievance-table [tableheadersAndData]="grievanceTable" [selectedTabIndex]="selectedTabIndex" [ngClass]="selectedTabIndex"></app-grievance-table>
    </div>
    
    <div *ngIf="selectedTabIndex == 'addressGrievance'" class="pb-10">
      <div *ngIf="grievanceTable.tableData.length > 0; else noDataFound">
        <ion-row>
          <ion-col size="6" size-sm="auto">
            <app-grievance-total-count [countData]="{ value: 'Total', count: grievanceTable.tableData.length}"></app-grievance-total-count>
          </ion-col>
          
          <ion-col size="6" size-sm="auto" *ngFor="let status of grievanceServicesService.statusType">
            <app-grievance-total-count [countData]="status"></app-grievance-total-count>
          </ion-col>
        </ion-row>
        <app-grievance-table [tableheadersAndData]="grievanceTable" [selectedTabIndex]="selectedTabIndex" [ngClass]="selectedTabIndex"></app-grievance-table>
      </div>
      <ng-template #noDataFound>
        <h4 class="font_bold pt-20 pb-20 pl-10 pr-10">No Grievance Found</h4>
      </ng-template>
    </div>
  </section>
</ion-content>


